<template lang="pug">
.briq-form-element.briq-input
  label(:for="name" v-if="label") {{ label }} 
  briq-required-and-optional-markers(:isRequired="this.$attrs.required" :isDisabled="this.$attrs.disabled || this.$attrs.readonly" :hideOptionalMarker="hideOptionalMarker" :label="label")
  briq-tooltip(:help="help")
  .input-wrapper.flex
    // todo: make these buttons
    .plus-minus-btn-holder.minus(
      @click="operateNumber('substract')"
      :disabled="isDisabled || disableMinus"
      data-test-id="number-input-minus-button"
      )
      svg.icon.icon-input-min-icon
        use(xlink:href="#icon-input-min-icon")
    BriqInput.input(
      :name="name"
      :id="name"
      v-model.number="innerValue"
      type="number"
      v-bind="$attrs"
      :disabled="isDisabled || disableInput"
      @focus="$event.target.select()"
      :required="false"
      :readonly="readonlyInput"
      :style="inputWidth"
      :hideSpinners="true"
      )
    .plus-minus-btn-holder.plus(
      @click="operateNumber('add')"
      :disabled="isDisabled || disablePlus"
      data-test-id="number-input-plus-button"
      )
      svg.icon.icon-input-plus-icon
        use(xlink:href="#icon-input-plus-icon")
  .validation-message(v-if="error") {{ error }}
</template>

<script>
export default {
  name: 'BriqNumberInputWithButtons',
  props: {
    label: String,
    name: String,
    hideOptionalMarker: {
      type: Boolean,
      default: false,
    },
    help: String,
    error: String,
    value: Number,
    disablePlus: Boolean,
    disableInput: Boolean,
    readonlyInput: Boolean,
    disableMinus: Boolean,
    maxInputAllowed: Number,
  },
  inheritAttrs: false,
  data() {
    return {
      inputWidth: 'width: 60px',
    }
  },
  computed: {
    isDisabled() {
      return this.$attrs.disabled === '' || this.$attrs.disabled === true
    },
    innerValue: {
      get() {
        return this.value
      },
      set(v) {
        const number = typeof v === 'number' ? v : parseInt(v) || 0
        const emitValue =
          this.maxInputAllowed && number > this.maxInputAllowed ? this.maxInputAllowed : number
        this.$emit('input', emitValue)
      },
    },
  },
  methods: {
    operateNumber(operation) {
      if (this.isDisabled) return
      if (operation === 'add' && !this.disablePlus) this.innerValue = this.innerValue + 1
      if (operation === 'substract' && !this.disableMinus)
        this.innerValue = this.innerValue > 0 ? this.innerValue - 1 : this.innerValue
    },
  },
}
</script>

<style scoped lang="stylus">
.input-wrapper
  position relative


.plus-minus-btn-holder
  border solid 1px #ebebeb
  border-radius 50px
  width 38px
  height 38px
  cursor pointer

  &[disabled]
    background #eee
    color #2c333a
    cursor not-allowed

.plus-minus-btn-holder:hover
  background-color #F1F3F6

.plus, .minus
  display flex
  justify-content center
  align-items center

.plus
  margin-left 10px

.minus
  margin-right 10px
</style>
